<template>
  <div></div>
  <!-- <Dialog :visible="visible" @hide="onHide" modal dismissableMask :closable="false" :style="{ width: '60vh', height: '60vh' }">
    <template #header>
      <h3>Добро пожаловать!</h3>
    </template>
    <div class="text-center">            
      <div class="flex flex-col items-center gap-4">
        <img src="@/assets/logo_n2.png" alt="Info" class="w-48 h-auto rounded" />       

        <div class="flex items-center justify-center gap-2 mt-4">
          <Checkbox v-model="doNotShowAgain" binary />
          <label for="doNotShow">Не показывать больше</label>
        </div>
        <div class="text-center mt-4">
          <Button label="Закрыть" @click="handleClosePopup" />
        </div>
      </div>  
    </div>
  </Dialog> -->
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';

export default {
  components: { Dialog, Checkbox, Button },

  data() {
    return {
      doNotShowAgain: false,
    };
  },

  computed: {
    ...mapState('popup', ['showInfoPopup']),
    visible() {
      return this.$store.state.popup.showInfoPopup;
    },
  },

  methods: {
    ...mapActions('popup', ['closePopup', 'skipPopupPermanently']),
    
    handleClosePopup() {      
      if (this.doNotShowAgain) {
        this.skipPopupPermanently();
      } else {
        this.closePopup();
      }
    },

    onHide() {
      console.log('onHide')
      this.$store.commit('popup/SET_INFO_POPUP', false);
    }
  },
};
</script>